import {
  Box,
  Card,
  CardContent,
  Grid,
  IconButton,
  Typography,
  Button,
} from "@mui/material";
import React, { useRef, useState } from "react";
import NewsHeader from "../componets/NewsHeader";
import Header from "../componets/Header";
import Footer from "../componets/Footer";
import { ArrowBackIos, ArrowForwardIos } from "@mui/icons-material";
import { motion, useInView } from "framer-motion";
import courses from "../../../../assets/about.png";
import c1 from "../../../../assets/c1.png";
import c2 from "../../../../assets/c2.jpg";
import c3 from "../../../../assets/c3.png";
import c4 from "../../../../assets/c4.jpg";
import c5 from "../../../../assets/c5.png";
import podar from "../../../../assets/podar.png";

const OurPrograms = () => {
  const scrollRef = useRef(null);
  const cardWidth = 320;
  const ref = useRef(null);
  const inView = useInView(ref, { once: false });
  const [expandedCards, setExpandedCards] = useState([]);

  const data = [
    {
      image: c1,
      title: "Play Group",
      age: "( Age 2-3 years)",
      context:
        "The program is designed around play and caters to the development of Physical and Socio-Emotional Skills. The activities in the curriculum help children build a foundation for playing, exploring and learning in a developmentally appropriate manner.",
      description:
        "Curriculum is focussed on basic colours, shapes, numeracy and literacy activities with a dash of precoding and science play activities. ",
    },
    {
      image: c2,
      title: "Nursery",
      age: "(Age 3 -4 years)",
      context:
        "The program is designed to give children a strong foundation of inquiry based learning through play, stories, dance and more. The activities in the curriculum help nurture the child’s growing brain and stimulate their language, communication and cognitive development. ",
      description:
        "Curriculum is focussed on learning more colours, shapes, numbers, the alphabet, emerging literacy and writing and numeracy with a sprinkling of precoding and science play activities.",
    },
    {
      image: c3,
      title: "Junior KG",
      age: "(Age 4-5 years)",
      context:
        "The program is infused with activities that help children in foundational literacy and numeracy and strengthen their language and communication skills. ",
      description:
        "Children enjoy logic and analytical activities in the curriculum that lead to exploration, thinking and understanding.Curriculum is focussed on learning primary and secondary colours, 3D and 2D shapes, writing capital and small letters of the alphabet, phonics, counting and writing numbers, basic number operations and a strong foundation of precoding and science activities.",
    },
    {
      image: c4,
      title: "Senior KG",
      age: "(Age 5-6 years)",
      context:
        "The program ensures that children are now able to read and write fluently and are strong in numerical skills. Children enjoy science and technology in a play infused manner and are now confident communicators, thinkers and creators.",
      description:
        "Curriculum focusses on reading blends, words, sentences, spellings, writing short sentences. Exploring naming and matching all kinds of shapes, primary, secondary and unusual colours. Numeracy activities, addition and subtraction, odd and even and many other concepts. Precoding activities and science and technology infusion.",
    },
    {
      image: c5,
      title: "DayCare",
      context:
        "A safe, nurturing space where care, comfort, and fun come together, ensuring holistic growth, social bonding, and happy learning. Our daycare supports working parents by offering a structured, safe, and joyful second home for your child.",
      description:
        "Children enjoy playtime, rest, storytelling, and supervised learning activities under caring guidance. Managed by trained staff, we ensure your child is well cared for, engaged in fun activities, and surrounded by love. We focus on comfort, routine, and personal attention to every child in our school. It’s safe, simple, and the perfect extension of your child’s school day. We’re here to support your child’s growth every step of the way — with care that feels just like home.",
    },
  ];

  const scroll = (direction) => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({
        left: direction === "left" ? -cardWidth - 20 : cardWidth + 20,
        behavior: "smooth",
      });
    }
  };

  const toggleExpand = (index) => {
    setExpandedCards((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
    );
  };

  return (
    <>
      <NewsHeader />
      <Header />
      {/* Banner */}
      <Box
        sx={{
          backgroundImage: `url(${courses})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          width: "auto",
          height: { xs: 200, md: 500 },
          display: "flex",
          textAlign: "center",
          alignItems: "center",
          // justifyContent: "space-between",
          padding: { xs: 2, md: 2 },
        }}
      >
        {/* Left - Text */}
        <Box sx={{ flex: 1 }}>
          <Typography
            sx={{
              color: "#fdce0d",
              fontSize: { xs: 30, md: 60 },
              fontWeight: "bold",
              fontFamily: "-moz-initial",
            }}
          >
            Our Programs
          </Typography>
        </Box>
      </Box>
      <Box sx={{ ml: { xs: 2, md: 20 }, mt: { xs: -8, md: -20 } }}>
        <Box
          component="img"
          src={podar}
          alt="podar"
          sx={{
            width: { xs: 100, md: 250 },
            height: { xs: 100, md: 250 },
            objectFit: "contain",
          }}
        />
      </Box>

      <Grid
        container
        justifyContent="center"
        alignItems="center"
        sx={{
          padding: { xs: "20px", md: "50px" },
          textAlign: "center",
          position: "relative",
          margin: "auto",
          backgroundColor: "#fff",
        }}
      >
        <Grid item xs={12}>
          <motion.div
            ref={ref}
            initial={{ opacity: 0, y: 50 }}
            animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
            transition={{ duration: 0.8 }}
          >
            <Typography
              sx={{
                fontFamily: "-moz-initial",
                color: "#005ca8",
                fontWeight: "bold",
                maxWidth: { xs: "95%", md: "60%" },
                lineHeight: 1.2,
                textAlign: "center",
                mx: "auto",
                fontSize: { xs: "24px", md: "40px" },
                marginBottom: "10px",
              }}
            >
              Providing the best start to your Child’s education Journey
            </Typography>
            <Typography
              sx={{
                marginBottom: "20px",
                fontSize: { xs: "14px", md: "18px" },
                maxWidth: { xs: "98%", md: "80%" },
                textAlign: "center",
                mx: "auto",
              }}
            >
              Through our KIDUCATION approach, age-appropriate activities & the
              right balance of learning & fun, we ensure that your child’s
              introduction to schooling is positive in every way.
            </Typography>
          </motion.div>
        </Grid>

        {/* Scroll Left */}
        <IconButton
          sx={{
            position: "absolute",
            left: 0,
            top: "60%",
            backgroundColor: "#fff",
            transform: "translateY(-50%)",
            zIndex: 10,
          }}
          onClick={() => scroll("left")}
        >
          <ArrowBackIos />
        </IconButton>

        {/* Scrollable Cards */}
        <Grid
          item
          xs={12}
          sx={{
            display: "flex",
            overflowX: "auto",
            gap: { xs: 2, md: 2 },
            padding: "10px",
            scrollBehavior: "smooth",
            scrollbarWidth: "none",
            "-ms-overflow-style": "none",
            "&::-webkit-scrollbar": { display: "none" },
            minWidth: "100%",
          }}
          ref={scrollRef}
        >
          {data.map((item, index) => {
            const isExpanded = expandedCards.includes(index);
            const displayText = isExpanded
              ? `${item.context} ${item.description ? item.description : ""}`
              : item.context.slice(0, 100) + "...";

            return (
              <Card
                key={index}
                sx={{
                  width: `${cardWidth}px`,
                  minWidth: `${cardWidth}px`,
                  flexShrink: 0,
                  transition: "all 0.3s ease",
                  height: isExpanded ? "auto" : "600px",
                  color: isExpanded ? "red" : "600px",
                  backgroundColor: "#005ca8",
                  borderRadius: 5,
                  boxShadow: 3,
                }}
              >
                <CardContent sx={{ padding: 0 }}>
                  <Box sx={{ overflow: "hidden" }}>
                    <img
                      src={item.image}
                      alt={item.title}
                      style={{
                        width: "100%",
                        height: "250px",
                        objectFit: "cover",
                      }}
                    />
                  </Box>
                  <Box sx={{ padding: "10px", color: "#fff" }}>
                    <Typography
                      sx={{
                        fontSize: { xs: 20, md: 25 },
                        fontWeight: "bold",
                        marginTop: "10px",
                        fontFamily: "-moz-initial",
                        textAlign: "left",
                        color: "#f5d44e",
                      }}
                    >
                      {item.title}
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: { xs: 20, md: 20 },
                        fontWeight: "bold",
                        fontFamily: "-moz-initial",
                        textAlign: "left",
                        color: "#f5d44e",
                      }}
                    >
                      {item.age}
                    </Typography>
                    <Typography
                      paragraph
                      sx={{
                        mt: 1,
                        textAlign: "justify",
                        fontSize: { xs: "12px", md: "16px" },
                      }}
                    >
                      {item.context}
                    </Typography>

                    {isExpanded && item.description && (
                      <Typography
                        paragraph
                        sx={{
                          mt: 2,
                          textAlign: "justify",
                          fontSize: { xs: "12px", md: "16px" },
                        }}
                      >
                        {item.description}
                      </Typography>
                    )}

                    <Button
                      onClick={() => toggleExpand(index)}
                      sx={{
                        textAlign: "left",
                        fontSize: 18,
                        color: "#f5d44e",
                        textTransform: "none",
                        "&:hover": {
                          backgroundColor: "transparent",
                        },
                      }}
                    >
                      {isExpanded ? "Read Less" : "Read More"}
                    </Button>
                  </Box>
                </CardContent>
              </Card>
            );
          })}
        </Grid>

        {/* Scroll Right */}
        <IconButton
          sx={{
            position: "absolute",
            right: 0,
            top: "60%",
            backgroundColor: "#fff",
            transform: "translateY(-50%)",
            zIndex: 10,
          }}
          onClick={() => scroll("right")}
        >
          <ArrowForwardIos />
        </IconButton>
      </Grid>
      <Footer />
    </>
  );
};

export default OurPrograms;

